export default __webpack_public_path__ + "static/media/news69.a6972780.jpg";